function ExpenseTitle(props){
    return (
        <div>
            <h1>{props.title}</h1>
        </div>
    );
}

export default ExpenseTitle;